import {
  defaultFetch,
  httpMethod,
} from "@/scripts/Common/api";

import {
  getToken,
} from "@/scripts/Common/tokenService";

import {
  CreatePasswordChangeTicketV1Response,
  UpdateIdentityUserRequest,
} from "@/components/children/identityUsers/scripts/types";

const updateIdentityUser = async (userId: string, updateRequest: UpdateIdentityUserRequest, abortSignal? : AbortSignal)=> {
  const { error } = await defaultFetch({
    apiName: 'identityUsers',
    bearer: getToken(),
    body: JSON.stringify(updateRequest),
    options: {
      method: httpMethod.PUT,
      routeParams: {
        userId
      },
      abortSignal
    }
  });

  return {
    error
  }
}

const changeIdentityUserState = async (userId: string, state: 'block' | 'unblock', abortSignal? : AbortSignal)=> {
  const { error } = await defaultFetch({
    apiName: 'changeIdentityUsersState',
    bearer: getToken(),
    options: {
      method: httpMethod.POST,
      routeParams: {
        userId,
        state
      },
      abortSignal
    }
  });

  return {
    error
  }
}

const deleteIdentityUser = async (userId: string, abortSignal? : AbortSignal)=> {
  const { error } = await defaultFetch({
    apiName: 'identityUsers',
    bearer: getToken(),
    options: {
      method: httpMethod.DELETE,
      routeParams: {
        userId
      },
      abortSignal
    }
  });

  return {
    error
  }
}

const resetPasswordViaEmail = async (userId: string, abortSignal? : AbortSignal)=> {
  const { error } = await defaultFetch({
    apiName: 'identityUserResetPasswordViaEmail',
    bearer: getToken(),
    options: {
      method: httpMethod.POST,
      routeParams: {
        userId
      },
      abortSignal
    }
  });

  return {
    error
  }
}


const createPasswordChangeTicket = async (userId: string, abortSignal? : AbortSignal)=> {
  const { error, response } = await defaultFetch({
    apiName: 'identityUserCreatePasswordChangeTicket',
    bearer: getToken(),
    options: {
      method: httpMethod.POST,
      routeParams: {
        userId
      },
      abortSignal
    }
  });

  return {
    error,
    response: response as CreatePasswordChangeTicketV1Response
  }
}

export {
  updateIdentityUser,
  changeIdentityUserState,
  deleteIdentityUser,
  resetPasswordViaEmail,
  createPasswordChangeTicket
}

